export default "/_next/static/chunks/fonts/Nunito-SemiBold-latin-19f5db60d489ad8ecd1dbaba3adefa85.woff2";